import React from 'react';

export const NotFound = (props) => {
    return <div className="no_data_found">{props.msg}</div>;
}

// export default NotFound;